<div *ngIf="type === 'bond-issuer'">
  <h1>Coming soon</h1>
</div>
<div *ngIf="type === 'certificate'">
  <h1>Coming soon</h1>
</div>
<div *ngIf="type === 'bond'">
  <h1>Coming soon</h1>
</div>